(function () {
  let pendingGift = null;
  let isAddingGift = false;
  let isCleaningGift = false;

  function getPromoBox() {
    return document.querySelector('.promo-gift[data-gift-variant-id]');
  }

  function getSelectedVariantId() {
    const input = document.querySelector('product-form input[name="id"], form[is="product-form"] input[name="id"], form input[name="id"]');
    return input ? String(input.value) : null;
  }

  function getQuantity() {
    const input = document.querySelector('product-form input[name="quantity"], form[is="product-form"] input[name="quantity"], form input[name="quantity"]');
    return input ? parseInt(input.value || '1', 10) : 1;
  }

  function getSectionsToBundle() {
    const sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', {
        bubbles: true,
        detail: { sections }
      })
    );
    return sections;
  }

  async function fetchCart() {
    return await fetch('/cart.js').then((res) => res.json());
  }

  async function addGiftToCart(gift) {
    const config = FoxTheme.utils.fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData();
    formData.append('id', gift.giftVariantId);
    formData.append('quantity', gift.quantity);
    formData.append('properties[_promo_gift]', 'true');
    formData.append('properties[_promo_parent_variant_id]', gift.parentVariantId);
    formData.append('properties[_promo_multiplier]', gift.multiplier);
    formData.append('sections', getSectionsToBundle());
    formData.append('sections_url', window.location.pathname);

    config.body = formData;

    const response = await fetch(FoxTheme.routes.cart_add_url, config);
    const parsedState = await response.json();

    const cartJson = await fetchCart();
    cartJson.sections = parsedState.sections;

    FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
      cart: cartJson
    });
  }

  async function removeOrphanPromoGifts() {
    if (isCleaningGift || isAddingGift) return;
    isCleaningGift = true;

    try {
      const cart = await fetchCart();

      const promoGifts = cart.items.filter(function (item) {
        return item.properties && item.properties._promo_gift === 'true';
      });

      let updatedCart = null;

      for (const gift of promoGifts) {
        const parentVariantId = gift.properties._promo_parent_variant_id;

        const parentExists = cart.items.some(function (item) {
          return (
            String(item.variant_id) === String(parentVariantId) &&
            !(item.properties && item.properties._promo_gift === 'true')
          );
        });

        if (!parentExists) {
          const response = await fetch(FoxTheme.routes.cart_change_url, {
            ...FoxTheme.utils.fetchConfig(),
            body: JSON.stringify({
              id: gift.key,
              quantity: 0,
              sections: getSectionsToBundle(),
              sections_url: window.location.pathname
            })
          });

          updatedCart = await response.json();
        }
      }

      if (updatedCart) {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
          cart: updatedCart
        });
      }
    } catch (error) {
      console.error('Promo gift cleanup error:', error);
    }

    isCleaningGift = false;
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[name="add"], button[type="submit"]');
    if (!button) return;

    const promoBox = getPromoBox();
    if (!promoBox) {
      pendingGift = null;
      return;
    }

    const selectedVariantId = getSelectedVariantId();
    const eligibleVariantId = String(promoBox.dataset.eligibleVariantId);

    if (selectedVariantId !== eligibleVariantId) {
      pendingGift = null;
      return;
    }

    const multiplier = parseInt(promoBox.dataset.giftMultiplier || '1', 10);
    const productQty = getQuantity();

    pendingGift = {
      giftVariantId: promoBox.dataset.giftVariantId,
      parentVariantId: selectedVariantId,
      quantity: productQty * multiplier,
      multiplier: multiplier
    };
  });

  document.addEventListener('product-ajax:added', async function () {
    if (!pendingGift || isAddingGift) return;

    isAddingGift = true;

    try {
      await addGiftToCart(pendingGift);
    } catch (error) {
      console.error('Promo engine error:', error);
    }

    pendingGift = null;
    isAddingGift = false;
  });

  document.addEventListener('cart:updated', function () {
    setTimeout(removeOrphanPromoGifts, 300);
  });

  if (window.FoxTheme && FoxTheme.pubsub) {
    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function () {
      setTimeout(removeOrphanPromoGifts, 300);
    });
  }
})();